import { render, staticRenderFns } from "./dlw.vue?vue&type=template&id=d5c9630a&scoped=true&"
var script = {}
import style0 from "./dlw.vue?vue&type=style&index=0&id=d5c9630a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c9630a",
  null
  
)

export default component.exports